const CN_USER = [
  "sam",
  "admin",
  "bar_se_operator",
  "sid",
  "mukeshverma",
  "bar_se_supervisor",
  "pat_hp_tester",
  "zir_ose_tester",
  "gau_mdp_tester",
  "vns_dta_tester",
  "blr_dis_tester",
  "nag_mms_tester",
  "rpr_m_tester",
  "amd_qls_tester",
  "lko_di_tester",
  "tester",
  "idr_npl_tester",
  "hub_mp_tester",
  "mum_me_tester",
  "meerut_tester",
  "jab_sre_tester",
  "mastercreator",
];

const CN_ALLOW_USER = [
  "amb_osmh_operator",
  "amb_osmh_supervisor",
  "nag_sp_operator",
  "jab_sre_operator",
  "nag_mms_operator",
  "var_pe_operator",
  "pat_ke_operator",
  "hwh_sa_operator_1",
  "hwh_sa_operator_2",
  "agr_ak_operator",
  "jai_ql_operator_2",
  "pnq_pil_operator_2",
  "omang",
  "pnq_pil_operator_2",
  "lko_di_operator_2",
  "lko_di_tester",
  "lko_di_operator_4",
  "lko_di_operator_3",
  "lko_di_operator_1",
  "lko_di_supervisor_1",
  "mum_me_operator",
  "mum_me_supervisor",
  "mum_me_operator2",
  "mum_me_tester",
];

const ALLOW_MT = [
  "lko_di_operator_2",
  "lko_di_tester",
  "lko_di_operator_4",
  "lko_di_operator_3",
  "lko_di_operator_1",
  "lko_di_supervisor_1",
  "jab_sre_supervisor",
  "jab_sre_operator",
  "tester",
  "mdu_va_operator_1",
  "mdu_va_supervisor_1",
  "vns_dta_operator",
  "vns_dta_supervisor",
];

const EXPIRY_ORDER_TYPE = ["ZRB", "ZRB2"];

const EXPIRY_ORDER_TYPEALL = ["ZRB", "ZRB2", "ZRI", "ZMD2", "ZPRB", "ZVT1"];

const INVOICE_ALLOW = ["ZRB", "ZRI", "ZMD2", "ZPRB", "ZVT1"];

const INVOICE_PLANT_MISMATCH_WARNING =
  "Exact plant invoice not found. Select the invoice with the correct plant code carefully.";

const INVOICE_REQUIRED_MESSAGE = "Invoice is required.";

export {
  CN_USER,
  EXPIRY_ORDER_TYPE,
  EXPIRY_ORDER_TYPEALL,
  INVOICE_ALLOW,
  INVOICE_PLANT_MISMATCH_WARNING,
  INVOICE_REQUIRED_MESSAGE,
  CN_ALLOW_USER,
  ALLOW_MT,
};
